<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="query.phone" placeholder="请输入手机号搜索" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
        </template>
        <template slot="btns" v-if="permission('/community/vest/add')">
            <el-button size="mini" icon="el-icon-plus" type="primary" @click="handleAdd">
                新增马甲号
            </el-button>
        </template>
        <template slot="columns">
            <el-table-column type="index" label="序号" width="100" align="center" />
            <el-table-column label="头像" align="center" prop="avatar">
                <template slot-scope="{ row }">
                    <img :src="row.avatar" alt="" style="width: 40px; height: 40px; border-radius: 50%;">
                </template>
            </el-table-column>
            <el-table-column label="昵称" align="center" prop="nickname"></el-table-column>
            <el-table-column label="手机号" align="center" prop="phone"></el-table-column>
            <el-table-column label="邮箱" align="center" prop="email"></el-table-column>
            <el-table-column label="操作" align="center" width="140" v-if="permission('/community/vest/cancel')">
                <template slot-scope="{ row }">
                    <el-link :underline="false" type="danger" @click="handleCancel(row)">
                        取消马甲号
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { page, edit } from "@/api/user/list";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                phone: "",
                mjFlag: 1,
                pageNo: 1,
                pageSize: 10,
            },
        };
    },
    mixins: [listMixin],
    mounted() {

    },
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
            };
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleAdd() {
            this.$router.push({ path: "/community/vest/form" });
        },
        handleCancel(row) {
            this.$confirm("确定要取消马甲号吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    edit({ ...row, mjFlag: 0 }).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("取消马甲号成功");
                            this.search();
                        } else {
                            this.$message.error(message);
                        }
                    });
                })
                .catch(() => { });
        },
    },
};
</script>